import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./Login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showWelcomeAnimation, setShowWelcomeAnimation] = useState(true);
  const [imageUrl] = useState("/ttec-logo-white_Full.png");
  const [securityAlert, setSecurityAlert] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcomeAnimation(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const reason = searchParams.get("reason");
    if (reason === "security") {
      setSecurityAlert("Security Alert: A potential security threat was detected. You have been logged out for your protection. Please sign in again to continue.");
      searchParams.delete("reason");
      setSearchParams(searchParams, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  const handleSSOLogin = async () => {
    setIsLoading(true);
    setError(null);

    setTimeout(() => {
      setIsLoading(false);
    }, 5000);

    window.location.replace(
      `${process.env.REACT_APP_MIDDLEWARE_API_BASE_URL}/login`
    );
  };

  return (
    <div className="login-container">
      {/* Background Elements */}
      <div className="background-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      {/* Welcome Animation Overlay */}
      {showWelcomeAnimation && (
        <div className="welcome-overlay">
          <div className="welcome-content">
            <div className="logo-animation">
              <div className="company-logo">
                <img src={imageUrl} className="imageStyle p-2" alt="Logo" />
              </div>
              <div className="welcome-text">Career Card</div>
            </div>
            <div className="loading-spinner">
              <div className="spinner"></div>
            </div>
          </div>
        </div>
      )}

      <div className="main-content">
        {/* Header Section */}
        <div className="header-section">
          <div className="brand-header">
            <div className="brand-logo">
              <div className="logo-circle">
                <span className="logo-text">
                  <img src={imageUrl} className="imageStyle p-2" alt="Logo" />
                </span>
              </div>
            </div>
            <h1 className="brand-title">Career Card</h1>
            <p className="brand-subtitle">
              Empowering your professional journey
            </p>
          </div>
        </div>

        {/* Login Card */}
        <div className="login-card">
          <div className="card-header">
            <h2 className="card-title">Access Your Career Card</h2>
            <p className="card-subtitle">
              Sign in to manage your professional development
            </p>
          </div>

          <div className="card-body">
            {securityAlert && (
              <div className="security-alert">
                <span className="security-message">{securityAlert}</span>
                <button className="security-close" onClick={() => setSecurityAlert(null)}>
                  X
                </button>
              </div>
            )}

            {error && (
              <div className="error-alert">
                <i className="bi bi-exclamation-triangle-fill error-icon" aria-hidden="true"></i>
                <span className="error-message">{error}</span>
                <button className="error-close" onClick={() => setError(null)} aria-label="Close error">
                  <i className="bi bi-x" aria-hidden="true"></i>
                </button>
              </div>
            )}

            {/* SSO Login Section */}
            <div className="sso-section">
              <button
                type="button"
                className={`sso-button ${isLoading ? "loading" : ""}`}
                onClick={handleSSOLogin}
                disabled={isLoading}
              >
                <div className="button-content">
                  <i className="bi bi-shield-check button-icon" aria-hidden="true"></i>
                  <span className="button-text">
                    {isLoading ? "Signing in..." : "Sign in with TTEC SSO"}
                  </span>
                  {isLoading && <div className="button-spinner"></div>}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
